import { FTButtonVariants, MuiButtonVariants } from './types';
import { MuiColors } from '../../theme/types';
import type { Theme } from '@mui/material/styles';

export const hoverBackground = (
  variant: FTButtonVariants,
  theme: Theme,
): string => {
  switch (variant) {
    case 'main':
      return theme.palette.colors.purple[600];
    case 'secondary':
      return theme.palette.colors.purple[200];
    case 'danger':
      return theme.palette.colors.red[600];
    default:
      return theme.palette.colors.purple[100];
  }
};

export const borderColor = (
  variant: FTButtonVariants,
  theme: Theme,
): string => {
  switch (variant) {
    case 'main':
      return theme.palette.colors.purple[300];
    case 'secondary':
      return theme.palette.colors.purple[400];
    case 'danger':
      return theme.palette.colors.red[300];
    default:
      return theme.palette.colors.purple[100];
  }
};

export const FTVariantMuiColorMap: Record<FTButtonVariants, MuiColors> = {
  main: 'primary',
  secondary: 'secondary',
  ghost: 'primary',
  danger: 'error',
};

export const FTMuiButtonVariantMap: Record<
  FTButtonVariants,
  MuiButtonVariants
> = {
  main: 'contained',
  secondary: 'contained',
  ghost: 'text',
  danger: 'contained',
};

export const getFTVariantLoadingIconColorMap = (
  theme: Theme,
): Record<FTButtonVariants, string> => ({
  main: theme.palette.colors.white,
  secondary: theme.palette.colors.purple[500],
  ghost: theme.palette.colors.purple[500],
  danger: theme.palette.colors.white,
});
